import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[var(--mep-black)] text-white flex items-center justify-center px-5">
      <div className="max-w-lg w-full text-center">
        <XCircle size={56} className="mx-auto text-[var(--mep-pink)]" />
        <h1 className="font-display text-3xl md:text-4xl font-light mt-6 tracking-tighter">Pago cancelado</h1>
        <p className="text-[var(--mep-text-muted)] mt-3">
          No se realizó ningún cargo. Puedes intentarlo cuando quieras.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            data-testid="cancel-retry-btn"
            onClick={() => navigate("/pago")}
            className="btn-pink px-8 py-4 font-semibold"
          >
            Reintentar pago
          </button>
          <button
            data-testid="cancel-home-btn"
            onClick={() => navigate("/")}
            className="btn-gold-outline px-8 py-4 font-semibold"
          >
            Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
}
